<template>
  <styled-subheading>{{ $t('generic.settings') }}</styled-subheading>
  <workspace-form
    :disabled="!canManageWorkspaces"
    :initial-values="workspace"
    :mode="WorkspaceFormMode.EDIT"
    @submit="handleSubmit"
  ></workspace-form>
  <workspace-owners-management :workspace-id="workspace._id" />
  <workspace-reviewers-management :workspace-id="workspace._id" />
</template>

<script lang="ts" setup>
  import { useRoles } from '@/composables/useRoles';
  import { IWorkspaceDetailsDto } from 'types';
  import {
    WorkspaceFormFields,
    WorkspaceFormMode,
  } from '../WorkspaceForm/WorkspaceForm.types';
  import { useSaveWorkspace } from '@/composables/api/workspaces/useSaveWorkspace';
  import WorkspaceReviewersManagement from '../WorkspaceReviewersManagement/WorkspaceReviewersManagement.vue';

  const emit = defineEmits<{
    (e: 'update'): void;
  }>();

  const props = defineProps<{ workspace: IWorkspaceDetailsDto }>();

  const { updateWorkspace } = useSaveWorkspace();
  const { canManageWorkspaces } = useRoles();

  async function handleSubmit(
    workspaceFormData: WorkspaceFormFields,
  ): Promise<void> {
    await updateWorkspace(props.workspace._id, workspaceFormData);
    emit('update');
  }
</script>
